import "./Widget.css";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { LVForm } from "../../Basicos/LVForm";
import { SimpleItem } from 'devextreme-react/form';

export const Widget = ({ titulo, tituloLink, link, icono, Monto, Cantidad, PorcentajeMonto, PorcentajeCantidad, MuestraMonto }) => {

  var classNamePorcentajeMonto = "percentagePositive";
  var PositivoMonto = true
  if (PorcentajeMonto < 0) {
    classNamePorcentajeMonto = "percentageNegative"
    PositivoMonto = false;
  }

  var classNamePorcentajeCantidad = "percentagePositive";
  var PositivoCantidad = true
  if (PorcentajeCantidad < 0) {
    classNamePorcentajeCantidad = "percentageNegative"
    PositivoCantidad = false;
  }

  return (
    <div className="widget">
      <div className="title">
        {icono} {titulo}
      </div>
      <br />
      <span className="title">Cantidad</span>
      <br />
      <span className="counter">{Cantidad}</span>

      <span className={classNamePorcentajeCantidad}>
        {PositivoCantidad ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        {PorcentajeCantidad} %
      </span>
      <br />
      <span className="title">Monto</span>
      <br />
      <span className="counter">$ {Monto}</span>

      <span className={classNamePorcentajeMonto}>
        {PositivoMonto ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        {PorcentajeMonto} %
      </span>
      <br />
      <br />
      <a href={link} className="tituloLink">
        {tituloLink}
      </a>
    </div>
  );
};
